import { createContext } from 'react';

export const SurfContext = createContext('');
